import React from "react";

type TFrontTitleHeaderHeading = "h1";

type TFrontTitleHeader = {
    heading?: TFrontTitleHeaderHeading;
};

class FrontTitleHeader extends React.Component<React.PropsWithChildren<TFrontTitleHeader>> {
    public render (): JSX.Element {
        return (
            <div className="front-title-header">
                {this.props.heading === "h1"
                    ? <h1 className="front-title-header__heading">{this.props.children}</h1>
                    : this.props.children
                }
            </div>
        );
    }
}

export default FrontTitleHeader;
